import React from "react";
import { connect } from "react-redux";
import { resetPasswordRequest } from "../../store/iam/operations";
import { loadingResetPasswordRequest } from "../../store/iam/selectors";
import { ForgotPasswordForm } from "../../components/auth";

function ForgotPassword({ isLoading, resetPasswordRequest }) {
    const onFormSubmit = (email) => {
        resetPasswordRequest(email);
    };

    return <ForgotPasswordForm onSubmit={onFormSubmit} isLoading={isLoading} />;
}

const mapStateToProps = (state) => ({
    isLoading: loadingResetPasswordRequest(state)
});

export default connect(mapStateToProps, { resetPasswordRequest })(ForgotPassword);
